import Tools from "../Tools";
import ad_device from "../vo/dbvo/ad_device";
import ad_device_account_map from "../vo/dbvo/ad_device_account_map";
import ad_device_topic_map from "../vo/dbvo/ad_device_topic_map";
import ad_topic from "../vo/dbvo/ad_topic";

export type InputBindTopicToDevice = {
    TopicUniqueIdentifier: string;
    DeviceUniqueIdentifier: string;
};

/**
 * 设备API
 */
export default class DeviceApi {
    /**
     * 添加设备
     * @param device_unique_identifier 
     * @param deviceName 设备名称
     * @returns 
     */
    public AddAsync(device_unique_identifier: string, deviceName: string) {
        return Tools.FetchAsync("Device/Add", {
            device_unique_identifier,
            deviceName
        }, "GET");
    }

    /**
     * 设置设备名称
     * @param deviceUniqueIdentifier 
     * @param deviceName 
     */
    public SetDeviceNameAsync(deviceUniqueIdentifier: string, deviceName: string) {
        return Tools.FetchAsync(`Device/SetDeviceName?deviceUniqueIdentifier=${deviceUniqueIdentifier}&deviceName=${deviceName}`, {

        }, "PATCH");
    }

    /**
     * 设置设备备注名
     */
    public SetDeviceRemarksNameAsync(deviceUniqueIdentifier: string, deviceRemarksName: string) {
        return Tools.FetchAsync(`Device/SetDeviceName?deviceUniqueIdentifier=${deviceUniqueIdentifier}&deviceRemarksName=${deviceRemarksName}`, {

        }, "PATCH");
    }

    /**
     * 获取我的设备列表
     * @param page 
     * @param pageSize 
     */
    public GetMyDevicesListAsync(page: number, pageSize: number) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: {
                device: ad_device,
                device_map: ad_device_account_map
            }[]
        }>(`Device/GetMyDevicesList`, {
            page,
            pageSize
        }, "GET");
    }

    /**
     * 是否存在该设备
     * @param deviceNumber 
     */
    public async HasDeviceFromDeviceNumberAsync(deviceNumber: string) {
        let resp = await Tools.FetchAsync<{
            has: boolean
        }>("Device/HasDeviceFromDeviceNumber", {
            deviceNumber
        }, "GET", "text/plain", true);
        if (resp.CheckIsOk()) {
            return resp.Data!.has;
        }
        return false;
    }


    /**
     * 绑定设备到子账号
     */
    public BindDeviceToUidAsync(deviceUniqueIdentifier: string, toUid: string) {
        return Tools.FetchAsync(`Device/GetMyDevicesList?deviceUniqueIdentifier=${deviceUniqueIdentifier}&toUid=${toUid}`, {
        }, "POST");
    }

    /**
     * 根据设备号获取设备需订阅的主题
     * @param deviceUniqueIdentifier 
     */
    public GetTopicFromDeviceUniqueIdentifierAsync(deviceUniqueIdentifier: string) {
        return Tools.FetchAsync<{
            dtm: ad_device_topic_map,
            topic: ad_topic
        }[]>(`Device/GetTopicFromDeviceUniqueIdentifier`, {
            deviceUniqueIdentifier
        }, "GET");
    }

    /**
     * 绑定主题到设备
     * @param input 
     */
    public BindTopicToDeviceAsync(input: InputBindTopicToDevice) {
        return Tools.FetchAsync(`Device/BindTopicToDevice`, input, "POST");
    }
}